import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import Button from 'components/ui/button';
import { cdnURL } from 'components/utils/cdn';
import Picture from 'components/ui/picture';
import { WavesPattern } from 'components/ui/icons';

import './styles.scss';

const CongratsPromo = ({ className }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const navigate = useNavigate();

  const onImageLoaded = () => {
    setTimeout(() => {
      setImageLoaded(true);
    }, 100);
  }

  const onClick = () => {
    navigate('/cards/congratulations');
  }

  return (
    <div className={`promo-container congrats-promo-container ${className}`}>
      <div className="background-pattern">
        <WavesPattern color="#94F1F2"/>
      </div>
      <div className={`image-container ${imageLoaded ? 'animate' : ''}`}>
        <Picture
          src={cdnURL('img/rebuild/promote/homepage/congrats-promo.png')}
          has2x
          hasWebp
          alt="Congratulations Cards"
          onLoaded={onImageLoaded}
        />
      </div>
      <p className="promo-text">Whatever the occasion you can never go wrong sending a card when congratulations are in order!</p>
      <Button onClick={onClick}>Congratulations Cards</Button>
    </div>
  );
}


CongratsPromo.propTypes = {
  className: PropTypes.string,
};

CongratsPromo.defaultProps = {
  className: ''
};

export default CongratsPromo;
